import React, { Component } from 'react';
import { Button, message } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import TableC from '../../basicElement/TableC';
import moment from 'moment';

const monthFormat = 'YYYY-MM';
class Filter extends Component {
    render() {
        const { businessList, ...rest } = this.props;
        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const filters = [{
            name: '统计时间',
            key: 'date',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '领域leader',
            key: 'leaderUser',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.user.queryLeaderList,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: '业务线',
            key: 'lineOfBusiness',
            type: 'select',
            typeProperty: {
                list: businessOption,
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} />
        )
    }
}

class ProjectVisitNum extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: false,
            sortParams: {},
            businessList:[],
            searchParams: {},
            curParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
        }
    }


    componentDidMount() {
        this.queryWithLevelByParams();
        this.queryEffectiveDate();
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { trueMonth, trueYear } = res;
            const { searchParams } = this.state;
            const date = `${trueYear}-${trueMonth < 10 ? `0${trueMonth}` : trueMonth}`;
            searchParams.date = date;
            this.setState({
                searchParams,
                curParams: {...searchParams},
            }, () => {
                this.loadData();
            });
        });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => this.setState({ businessList: res.typeConfigureList || [] }));
    }

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const params = this.splitParams(curParams);
        const options = {
            method: 'POST',
            url: API_URL.dashboard.querySitePlanVisitAmount,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                datas.forEach(el => {
                    el.date = curParams.date
                });
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: {
                ...searchParams,
            },
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, curParams } = this.state;
        const params = this.splitParams(curParams);
        const options = {
            method: 'POST',
            url: API_URL.dashboard.exportSitePlanVisitAmount,
            data: {
                ...sortParams,
                ...params,
                offset: 1,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
            },
        };
        $.sendRequest(options);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getColumns = () => {
        const columns = [{
            title: '统计月份',
            dataIndex: 'date',
            key: 'date',
            fixed: 'left',
            width: 80,
        },{
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            fixed: 'left',
            width: 80,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            fixed: 'left',
            width: 80,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            fixed: 'left',
            width: 140,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 140,
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            width: 120,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 80,
        }, {
            title: '项目阶段',
            dataIndex: 'stageNames',
            key: 'stageNames',
            width: 100,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 120,
        }, {
            title: '疾病',
            dataIndex: 'diseaseClassName',
            key: 'diseaseClassName',
            width: 120,
        }, {
            title: '项目PM工号',
            dataIndex: 'pmCode',
            key: 'pmCode',
            width: 100,
        }, {
            title: '项目PM姓名',
            dataIndex: 'pmUser',
            key: 'pmUser',
            width: 100,
        }, {
            title: '领域leader',
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            width: 100,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 160,
        }, {
            title: '中心科室名称',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            width: 160,
        }, {
            title: '中心计划访视类型',
            dataIndex: 'visitTypeName',
            key: 'visitTypeName',
            width: 100,
        }, {
            title: `中心计划访视数量`,
            dataIndex: 'amount',
            key: 'amount',
            width: 100,
        }, {
            title: `是否已完成`,
            dataIndex: 'isCompleted',
            key: 'isCompleted',
            width: 80,
        }, {
            title: `中心计划标准访视数量`,
            dataIndex: 'standardAmount',
            key: 'standardAmount',
            width: 80,
        }];
        return columns;
    }
    
    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { exportable } = this.props;
        const { data, loading, pagination, searchParams, sortParams, businessList } = this.state;
        return (
            <div>
                <div className="reportTitle">{this.props.title}</div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    onChange={this.handleFilterChange}
                    businessList={businessList}
                    buttons={[
                        <Button key="export" type="primary" onClick={this.export} style={{marginLeft: 8}}>导出</Button>
                    ]}
                />
                <div style={{marginTop: -20, marginBottom: 4, color: '#ffa500'}}>注：由于数据量过大，页面仅展示其中一个项目一个中心的数据，请导出后查看完整数据</div>
                <TableC
                    data={data}
                    loading={loading}
                    className="crcMonthInGroup"
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
            </div>
        );
    }
}

export default ProjectVisitNum;


// WEBPACK FOOTER //
// ./src/components/homePage/statement/projectVisitNum.js